"use client";

import moment from "moment";
import { useCallback } from "react";
import Link from "next/link";

import PostCardImg from "../PostCardImg";
import Badges from "../Badges";
const styles = new Proxy({"PostCard":"PostCard-ff374","CardTitle":"CardTitle-ff374","CardText":"CardText-ff374","CardBody":"CardBody-ff374","CardFooter":"CardFooter-ff374"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import { Post } from "../BlogTeaser";

interface PostCardProps {
  post: Post;
  isFirst: boolean;
  className?: string;
  router?: any;
}

const PostCard = ({
  post,
  isFirst,
  className = "col-lg-4",
  router,
}: PostCardProps) => {
  const onClick = useCallback(() => {
    router?.push(`/blog/${post.slug}`);
  }, [router, post.slug]);

  return (
    <div className={`my-3 col-lg-4 ${className}`}>
      <div className={styles.PostCard}>
        <PostCardImg
          post={{
            featuredImage: post.titleImage?.url,
            link: `/post/${post.slug}`,
          }}
          priority={isFirst}
        />

        <div className={styles.CardBody} onClick={onClick} role="link">
          <div className="mb-2" style={{ fontSize: 14, color: "#738795" }}>
            <strong>{post.author.name}</strong>
            <span className="ms-2">
              {moment(post.scheduledAt).format("MMMM D, YYYY")}
            </span>
          </div>

          <h3 className={styles.CardTitle}>
            <Link href={`/post/${post.slug}`}>
              <span
                dangerouslySetInnerHTML={{ __html: post.title }}
                suppressHydrationWarning
              />
            </Link>
          </h3>

          <div className={styles.CardText}>
            <p>{post.excerpt}</p>
          </div>

          <div className="mt-3">
            <Link href={`/post/${post.slug}`} className="mainlink">
              Read more
            </Link>
          </div>
        </div>

        <div className={styles.CardFooter}>
          <Badges badges={post.tags} limit={2} />
        </div>
      </div>
    </div>
  );
};

export default PostCard;
